export default "<router-outlet *ngIf=\"!isIframe\"></router-outlet>\r\n"